import {
  Box,
  Button,
  Divider,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { FC, useEffect, useMemo, useState } from "react";
import { FormDistribuidorRevenda } from "./FormDistribuidorRevenda";
import { BottomBar } from "src/framework/components/commons/BottomBar";
import { PageTitle } from "./PageTitle";
import { Projeto } from "./types";
import { ValidateUtil } from "src/framework/commons/ValidateUtil";
import theme from "src/theme/light";
import { useObservable } from "src/framework/store/storeUtil";
import { isLoading$ } from "src/framework/store/ApiEvents";
import { FormClienteAvulso } from "./FormClienteAvulso";
import { FormItensAvulsos } from "./FormItensAvulsos";
import { formState$ } from "src/store/vendas/projetos/store";
import { TermosProjeto } from "./containers/TermosProjeto";
import { Formater, TypeRecords } from "src/framework/commons/Formater";

interface FormClientProperties {
    formState: any;
    onChangeValue: (formState: any) => void
    errorState: string[];
    onChangeError: (errorState: any) => void
    distribuidorRevendaUsuario: any
    readOnly?: boolean
    onClickNext: () => void
}

const useStyles = makeStyles({
  customButton: {
    backgroundColor: '#CC8F00'
  },
  valores: {
    display: "flex",
    flexDirection: "row",
    gap: "15px"
  },
})

const FormDadosAvulso: FC<FormClientProperties> = ({ onClickNext, readOnly, formState, onChangeValue, errorState, onChangeError, distribuidorRevendaUsuario }) => {
  const classes = useStyles()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const FooterBottom = isMobile ? Box : BottomBar;
  const isLoading = useObservable(isLoading$);
  const globalFormState = useObservable(formState$)
  const [valorTotal, setValorTotal] = useState<number>()
  
  const nextButtonIsDisabled = useMemo(() => {
    const requiredFields: (keyof Projeto)[] = [
      "cliente_proposta",
      "estado",
      "termo_aceito"
    ]

    for (const requiredField of requiredFields) {
      if (!formState?.[requiredField]) {
        return true;
      }
    }

    if (isLoading) return true;

    if (formState?.email_proposta && (!ValidateUtil.isValidEmail(formState?.email_proposta) || errorState?.includes('email_proposta'))) return true;

  }, [formState, errorState, isLoading])

  useEffect(()=>{
    if(globalFormState?.avulsos){
      const valorTotalAvulsos = globalFormState?.avulsos?.reduce((total: any, produto: any) => {
          return total + (produto?.valor * produto?.quantidade);
      }, 0);
      setValorTotal(valorTotalAvulsos)
    }
  },[globalFormState?.avulsos])
  return (
    <>
      <Box p={2}>
        <PageTitle title={"Dados iniciais"} subtitle='Preencha os dados do cliente para faturamento.' />
      </Box>

      <Divider className="X12" />

      <Box p={2}>
        <FormDistribuidorRevenda
          errorState={errorState}
          formState={formState}
          distribuidorRevendaUsuario={distribuidorRevendaUsuario}
          onChangeError={onChangeError}
          onChangeValue={onChangeValue}
        />
        <FormClienteAvulso 
            errorState={errorState}
            formState={formState}
            onChangeError={onChangeError}
            onChangeValue={onChangeValue}
        />
        <Box style={{marginTop: '30px'}}>
          <FormItensAvulsos formState={globalFormState}/>
        </Box>
        <Box style={{marginTop: '30px'}}>
          <TermosProjeto
            checked={formState.termo_aceito}
            setChecked={(selecionado, dados_termo) => onChangeValue({ termo_aceito: selecionado, dados_termo })}
          />
        </Box>
        <Box style={{marginTop: '30px'}}>
          <Typography color='primary' align='left' variant='h6'><strong>Valores:</strong></Typography>
          <Box className={classes.valores}>
            <Box style={{fontSize: "16px", display: "flex", flexDirection: "row", gap: "5px"}}>
              <Typography align='left'>Total Produtos</Typography>
              <Typography color="primary" align='right'>{Formater.toString(valorTotal, TypeRecords.CURRENCY)}</Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      <FooterBottom className="fotter-bottom">
        {!readOnly && 
          <Tooltip title={nextButtonIsDisabled ? 'Para prosseguir, preencha os campos marcados como *obrigatório.' : ''}>
            <span>
              <Button
                disableElevation={true}
                disabled={nextButtonIsDisabled}
                color={"primary"}
                variant={"contained"}
                onClick={onClickNext}
                fullWidth={isMobile}
                style={isMobile ? { marginTop: 10 } : {}}
                >
                Finalizar projeto
              </Button>
            </span>
          </Tooltip>
        }

        {!readOnly && nextButtonIsDisabled && isMobile && <Box className="label-inputs" color="">
          <small>Para prosseguir, preencha os campos marcados como <span className="label-emphasis">*</span>obrigatório.</small>
        </Box>}
      </FooterBottom>
    </>
  )
}

export { FormDadosAvulso }